const fontSizes = ['1rem', '1.1rem', '1.2rem', '1.3rem']

export default fontSizes